import {
  doesStringContainsNumber,
  getNumberFromString,
  isNumberDecimal,
} from "src/hooks/table/cells/useGetFormattedDecimalValue/utils";
import { ValueFormat } from "src/requests/templates/types";
import { formatMsg } from "src/utils/intl/intlFormmaters";
import { MAX_CHAR_COUNT_IN_WORD } from "../FlowioInput/constants";

export const findLongestWord = (str: string) => {
  const longestWord = str
    .split(" ")
    .reduce(
      (longest, currentWord) =>
        currentWord.length > longest.length ? currentWord : longest,
      ""
    );
  return longestWord;
};

export const shortenLongWord = (str: string) => {
  const longestWord = findLongestWord(str);

  return str.replaceAll(
    longestWord,
    longestWord.slice(0, MAX_CHAR_COUNT_IN_WORD)
  );
};

export const sentenceContainsLongWord = (
  sentence: string
): boolean | string => {
  const longestWord = findLongestWord(sentence);

  if (!longestWord) return true;

  if (longestWord.length < MAX_CHAR_COUNT_IN_WORD) {
    return true;
  }

  return formatMsg("input.text.maxLength");
};

export const doesSentenceContainsInvalidDecimal = (
  sentence: string,
  maxDecimalCount: number,
  format?: ValueFormat
): boolean => {
  if (!isNumberDecimal(format) || !doesStringContainsNumber(sentence, format))
    return false;

  const stringNumber = getNumberFromString(sentence, format);

  const [_, decimal] = stringNumber.split(/\.|,/);

  if (!decimal) return false;

  return decimal.length > maxDecimalCount;
};

export const getAdjustedStringDueToDecimal = (
  valueToAdjust: string,
  separator: string,
  format?: ValueFormat
): string => {
  if (!isNumberDecimal(format)) return valueToAdjust;

  if (valueToAdjust.match(/[0-9](\.|,)$/)) {
    return valueToAdjust.replace(/(\.|,)$/, separator);
  }

  if (valueToAdjust.match(/(,|\.)\s$/)) {
    return valueToAdjust.replace(/\s$/, "");
  }

  return valueToAdjust;
};
